module.exports = __webpack_public_path__ + "img/3f_selfactualization.b89dcf90.svg";